import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { bootstrapLegacyCookie } from './services/api'
import './index.css'

// [F2 2026-07-02] GATE de arranque: si hay un token legacy en localStorage (sesion
// pre-cookie), canjearlo por la cookie httpOnly ANTES de montar React. Sin este gate,
// el burst inicial de requests corre en paralelo con el canje y 401ea (race del deploy).
// Sin token legacy resuelve al tiro (0ms extra post-transicion).
bootstrapLegacyCookie().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
